var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194.29 94.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#00a193;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.21.5c26.4,0,38.72,22.74,38.72,46.56s-12.32,46.7-38.72,46.7S.5,70.89.5,47.06,12.82.5,39.21.5Zm0,20.57c-10.83,0-15.16,10-15.16,26s4.33,26.13,15.16,26.13S54.37,63,54.37,47.06,50,21.07,39.21,21.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.39,64.25C101.89,70.62,112.17,74,120,74c10,0,15.16-4.06,15.16-9.34s-3.79-8.26-16.1-8.26c-3.93,0-10.83.14-12.19.27v-20c1.76.14,8.8.14,12.19.14,9.34,0,14.62-2.71,14.62-7.72,0-5.68-6.5-8.66-15.16-8.66a35.09,35.09,0,0,0-22.75,8.93l-11-14.21C92.41,6.59,104.32.5,121,.5c23,0,35.87,9.88,35.87,24.77,0,10.56-9.07,18.55-19.76,20.31,9.61.94,21.25,8.39,21.25,21.38,0,15.84-14.89,26.8-37.36,26.8-17.32,0-30.32-6.09-37.36-14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.07,68.32A12.72,12.72,0,1,1,168.35,81,12.88,12.88,0,0,1,181.07,68.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.50a938398b7d02d4a9037998677bbe90.svg";
export { ForwardRef as ReactComponent };